import React, { Component } from 'react'
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBFormInline, Link
} from "mdbreact";
import {  MDBContainer, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip } from 'antd';
import { api, URL } from '../api';

export default class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      nameuser: '',
      admin_type: '',
      Username: '',
      collapse: false,
      isWideEnough: false,
    };
    this.onClick = this.onClick.bind(this);
    this.logout = this.logout.bind(this);
  }

    onClick() {
      this.setState({
        collapse: !this.state.collapse,
      });
    }
  
    
    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }


    componentDidMount() {
      //  const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('name') !== "") {
          this.setState({ nameuser: localStorage.getItem('name') })
          this.setState({ admin_type: localStorage.getItem('admin_type') })
        } else {
    
            this.setState({ admin_type: 'public' })
        }
         // this.setState({ nameuser: localStorage.getItem('nameuser') })
         // this.setState({ admin_type: localStorage.getItem('admin_type') })
      }


      logout() {
       //   localStorage.removeItem(('admin_type'))
       //  localStorage.removeItem(('nameuser'))
        localStorage.clear();
        setTimeout(() => {
        //  window.location.href = URL
          window.location.href = "/creditbank"
        }, 1000);
       // this.setState({ admin_type: 'public' }
        message.success("ออกจากระบบแล้ว")
      }



    render() {


        let logout
        logout = (
          <>
            <MDBNavItem>
              <MDBNavLink to="/main"> {this.state.nameuser}</MDBNavLink>
    
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    
        let superadmin
        superadmin = (
          <>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Check"><MDBIcon icon="file-alt" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/Showadmin"><MDBIcon far icon="user-circle" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="indent" /> จัดการหลักสูตร</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-indigo">
                <MDBDropdownItem> <Link to="/Curriculum"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตร</MDBDropdownItem></Link></MDBDropdownItem>
                {/* <MDBDropdownItem>  <Link to="/Curriculumshortterm"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตรระยะสั้น</MDBDropdownItem></Link></MDBDropdownItem> */}
                <MDBDropdownItem> <Link to="/Reportcurriculumall">  <MDBDropdownItem ><MDBIcon far icon="address-card" />ข้อมูลหลักสูตร</MDBDropdownItem></Link></MDBDropdownItem>
                 <MDBDropdownItem> <Link to="/Teacher">  <MDBDropdownItem ><MDBIcon far icon="address-card" />จัดการผู้สอน</MDBDropdownItem></Link></MDBDropdownItem>
                  <MDBDropdownItem> <Link to="/Student">  <MDBDropdownItem ><MDBIcon far icon="address-card" />จัดการผู้เรียน</MDBDropdownItem></Link></MDBDropdownItem>
                <MDBDropdownItem> <Link to="/Reportnumfaculty">  <MDBDropdownItem ><MDBIcon far icon="address-card" />รายงานข้อมูลจำนวนหลักสูตรแต่ละคณะ</MDBDropdownItem></Link></MDBDropdownItem>
                
                  {/* <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem> */}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Curriculum"><MDBIcon icon="user-circle" /> จัดการหลักสูตร</MDBNavLink>
            </MDBNavItem> */}

            {/* <MDBNavItem >
                 <MDBNavLink to="/Teacher"><MDBIcon far icon="address-card" /> จัดการผู้สอน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Student"><MDBIcon far icon="address-card" /> จัดการผู้เรียน</MDBNavLink>
            </MDBNavItem> */}
           
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="indent" /> จัดการเกียรติบัตร</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                <Link to="/Certificase"> <MDBDropdownItem ><MDBIcon far icon="address-card" /> แก้ไขเกียรติบัตร</MDBDropdownItem></Link>
                  {/* <Link to="/Reportcurriculumall">  <MDBDropdownItem ><MDBIcon far icon="address-card" />ข้อมูลหลักสูตร</MDBDropdownItem></Link> */}
                  {/* <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem> */}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

            {/* <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="indent" /> รายงานข้อมูล</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                <Link to="/Reportnumfaculty"> <MDBDropdownItem ><MDBIcon  icon="poll-h" /> รายงานข้อมูลจำนวนหลักสูตรแต่ละคณะ</MDBDropdownItem></Link>
                
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem> */}

            {/* <MDBNavItem >
                 <MDBNavLink to="/Curriculum"><MDBIcon icon="poll-h" /> รายงานข้อมูลรายวิชา</MDBNavLink>
            </MDBNavItem> */}
            {/* <MDBNavItem >
                 <MDBNavLink to="/Learn"><MDBIcon far icon="chart-bar" />ตารางเรียน</MDBNavLink>
            </MDBNavItem> */}
            {/* <MDBNavItem >
                 <MDBNavLink to="/Classroom"><MDBIcon far icon="chart-bar" />จัดการห้องเรียน</MDBNavLink>
            </MDBNavItem> */}


              <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="indent" /> จัดการหลักสูตรระยะสั้น</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-indigo">
                {/* <MDBDropdownItem> <Link to="/Curriculum"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตร</MDBDropdownItem></Link></MDBDropdownItem>
                <MDBDropdownItem>  <Link to="/Curriculumshortterm"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตรระยะสั้น</MDBDropdownItem></Link></MDBDropdownItem> */}
                <MDBDropdownItem>  <Link to="/Curriculumshorttermforadmin"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตรระยะสั้น</MDBDropdownItem></Link></MDBDropdownItem>
                <MDBDropdownItem> <Link to="/Reportcurriculumall">  <MDBDropdownItem ><MDBIcon far icon="address-card" />ข้อมูลหลักสูตรระยะสั้น</MDBDropdownItem></Link></MDBDropdownItem>
               <MDBDropdownItem> <Link to="/Reportnumfaculty">  <MDBDropdownItem ><MDBIcon far icon="address-card" />รายงานข้อมูลจำนวนหลักสูตรแต่ละคณะ</MDBDropdownItem></Link></MDBDropdownItem>
                
                  {/* <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem> */}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

              <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="indent" /> จัดการหลักสูตร MOOC</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-indigo">
                {/* <MDBDropdownItem> <Link to="/Curriculum"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตร</MDBDropdownItem></Link></MDBDropdownItem>
                <MDBDropdownItem>  <Link to="/Curriculumshortterm"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตรระยะสั้น</MDBDropdownItem></Link></MDBDropdownItem> */}
                {/* <MDBDropdownItem>  <Link to="/Curriculumshorttermforadmin"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตรระยะสั้น</MDBDropdownItem></Link></MDBDropdownItem> */}
                <MDBDropdownItem> <Link to="/Reportcurriculummooc">  <MDBDropdownItem ><MDBIcon far icon="address-card" />ข้อมูลหลักสูตMOOC</MDBDropdownItem></Link></MDBDropdownItem>
               {/* <MDBDropdownItem> <Link to="/Reportnumfaculty">  <MDBDropdownItem ><MDBIcon far icon="address-card" />รายงานข้อมูลจำนวนหลักสูตรแต่ละคณะ</MDBDropdownItem></Link></MDBDropdownItem> */}
                
                  {/* <MDBDropdownItem href="#!">Something else here</MDBDropdownItem>
                  <MDBDropdownItem href="#!">Something else here</MDBDropdownItem> */}
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
           

             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

        let student
        student = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/Studentmain"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem> 
            <MDBNavItem >
                 <MDBNavLink to="/Studentcheckregister"><MDBIcon far icon="credit-card" /> ข้อมูลลงทะเบียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Studentgradereport"><MDBIcon far icon="credit-card" /> รายงานผลการเรียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Studentportfolio"><MDBIcon icon="user-circle" /> ข้อมูลส่วนตัว</MDBNavLink>
            </MDBNavItem>
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"> <MDBIcon icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let teacher
        teacher = (
          <>
            <MDBNavItem className="hover-underline-animation ">
                 <MDBNavLink to="/Teachermain"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
          
            <MDBNavItem className="hover-underline-animation ">
                 <MDBNavLink to="/Curriculum"><MDBIcon icon="plus-square" /> จัดการหลักสูตร</MDBNavLink>
            </MDBNavItem>
          
            <MDBNavItem className="hover-underline-animation ">
                 <MDBNavLink to="/Results"><MDBIcon fab icon="wpforms" /> กรอกผลการเรียน</MDBNavLink>
            </MDBNavItem>


            {/* <MDBNavItem  >
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="home" /> จัดการหลักสูตร</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu class="dropdown-content" >
                <Link to="/Curriculum">  <MDBDropdownItem >จัดการหลักสูตร</MDBDropdownItem></Link> 
                <Link to="/Teachermain" >  <MDBDropdownItem >หลักสูตรที่เปิดสอน</MDBDropdownItem></Link>
                <Link to="/Results">  <MDBDropdownItem >กรอกผลการเรียน</MDBDropdownItem></Link>
             
                
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem> */}

            <MDBNavItem  className="hover-underline-animation ">
              <MDBDropdown  >
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="home" /> จัดการหลักสูตรระยะสั้น</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu class="dropdown-content " >
                <Link to="/Curriculumshortterm"  >  <MDBDropdownItem >จัดการหลักสูตรระยะสั้น</MDBDropdownItem></Link> 
                <Link  to="/Teachermainshort">  <MDBDropdownItem >หลักสูตรระยะสั้นที่เปิดสอน</MDBDropdownItem></Link> 
                <Link  to="/Resultsshort">  <MDBDropdownItem >กรอกผลการเรียนหลักสูตรระยะสั้น</MDBDropdownItem></Link> 
             
             
                
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>

      



           
            
           {/* <MDBNavItem >
                 <MDBNavLink to="/Curriculumshortterm"><MDBIcon icon="home" /> หลักสูตรระยะสั้น</MDBNavLink>
            </MDBNavItem> */}

            <MDBNavItem className="hover-underline-animation ">
                 <MDBNavLink to=""><MDBIcon icon="atlas" /> คู่มือ</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink><MDBIcon icon="atlas" />
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} className="hover-underline-animation ">
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />   ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )


        let admincu
        admincu = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/Teachermain"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Teachershortterm"><MDBIcon fab icon="algolia" /> หลักสูตรระยะสั้น</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/Admincumain"><MDBIcon icon="layer-group" /> พิจารณาหลักสูตร</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Admincumainshort"><MDBIcon icon="layer-group" /> พิจารณาหลักสูตรระยะสั้น</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Curriculum"><MDBIcon icon="plus-square" /> จัดการหลักสูตร</MDBNavLink>
            </MDBNavItem> */} 
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"><MDBIcon icon="indent" /> จัดการหลักสูตร</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-indigo">
                <MDBDropdownItem> <Link to="/Curriculum"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตร</MDBDropdownItem></Link></MDBDropdownItem>
                <MDBDropdownItem>  <Link to="/Curriculumshortterm"> <MDBDropdownItem ><MDBIcon far icon="address-card" />เพิ่มหลักสูตรระยะสั้น</MDBDropdownItem></Link></MDBDropdownItem>
               
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Results"><MDBIcon fab icon="wpforms" /> กรอกผลการเรียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to=""><MDBIcon icon="atlas" /> คู่มือ</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink><MDBIcon icon="atlas" />
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />   ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )

        let admindean
        admindean = (
          <>
            <MDBNavItem >
                 <MDBNavLink to="/Teachermain"><MDBIcon icon="home" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Admindeanmain"><MDBIcon icon="home" /> พิจารณาหลักสูตร</MDBNavLink>
            </MDBNavItem>
              {/* <MDBNavItem >
                 <MDBNavLink to="/Admindeanmain"><MDBIcon icon="home" /> พิจารณาหลักสูตรระยะสั้น</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/Admindeangrade"><MDBIcon icon="home" /> พิจารณาผลการเรียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Curriculum"><MDBIcon icon="plus-square" /> จัดการหลักสูตร</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Results"><MDBIcon fab icon="wpforms" /> กรอกผลการเรียน</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to=""><MDBIcon icon="atlas" /> คู่มือ</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/expert"><MDBIcon icon="home" /> สัดส่วนบทความvvvvvv</MDBNavLink><MDBIcon icon="atlas" />
            </MDBNavItem> */}
             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />   ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    

        let publics
        publics = (
          <>
            <MDBNavItem  >
              <MDBNavLink to="/">   หน้าหลัก </MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem  >
              <MDBNavLink to="/Register">   ลงทะเบียน </MDBNavLink>
            </MDBNavItem> */}
           
            {/* <MDBNavItem  >
              <MDBNavLink to="/main/LoginPages">  เข้าสู่ระบบ </MDBNavLink>
            </MDBNavItem> */}
          
          </>
        )

        const name = this.state.nameuser;

        return (
            <>
            
                <MDBNavbar color="deep-purple darken-1" dark expand="md" >
                    <MDBNavbarBrand>
                        <strong className="white-text">KPRU-CREDITBANK </strong>
                    </MDBNavbarBrand>
                    <MDBNavbarToggler onClick={this.toggleCollapse} />
                    <MDBCollapse id="navbarCollapse3" onCollapse={(e)=>{console.log(e)}} isOpen={this.state.isOpen}  navbar>
                        <MDBNavbarNav left>

                            {/* <MDBNavItem >
                                <MDBNavLink to="/"><MDBIcon icon="home" /> Home</MDBNavLink>
                            </MDBNavItem> */}
                      { localStorage.getItem('name') == null ? <>
                      {publics}
                    
                      </>:<>
                                      {/*  ผู้ดูแลระบบ */}
                                      {this.state.admin_type === '2' ? <>
                                      {superadmin}
                                      </> : null}

                                      {/*  นักศึกษา */}
                                      {this.state.admin_type === '3' ? <>
                                      {student}
                                      </> : null}

                                      {/*  อาจารย์ */}
                                      {this.state.admin_type === '4' ? <>
                                      {teacher}
                                      </> : null}

                                      {/*  เจ้าหน้าที่หลักสูตร */}
                                      {this.state.admin_type === '5' ? <>
                                      {admincu}
                                      </> : null}

                                      {/*  คณบดี */}
                                      {this.state.admin_type === '6' ? <>
                                      {admindean}
                                      </> : null}

                      </>}
                                                             
                                      {/* {this.state.admin_type === '3' ? <>
                                      {expert}
                                      </> : null}

                                      {this.state.admin_type === '4' ? <>
                                      {adminfaculty}
                                      </> : null}   */}
                              

                        </MDBNavbarNav>
                        <MDBNavbarNav right>
                            <MDBNavItem>
                                <MDBFormInline waves>
                                    <div className="md-form my-0">
                                        {/* <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" /> */}
                                        <MDBNavLink to=""> {localStorage.getItem('Univ_NAME')} </MDBNavLink>
                                    </div>
                                </MDBFormInline>
                            </MDBNavItem>
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBNavbar>


                

            </>
        )
    }
}

